import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export type TranslationLinkProps = {
  isUnderline?: boolean;
  block?: boolean;
  weight?: string;
};

const translationLinkStyle = css<TranslationLinkProps>`
  color: inherit;
  ${({ isUnderline }) => isUnderline && `text-decoration:underline;`}
  ${({ block }) => block && `display:block;`}
  ${({ weight }) => weight && `font-weight:${weight};`}
  &:visited {
    color: inherit;
  }
`;

export const TranslationLink = styled.a<TranslationLinkProps>`
  ${translationLinkStyle}
`;
export const TranslationLinkRouter = styled(Link)<TranslationLinkProps>`
  ${translationLinkStyle}
`;
